module.exports = {
  "calendar": "Calendario",
  "day": "d\xEDa",
  "dayPeriod": "a.\xA0m./p.\xA0m.",
  "endDate": "Fecha final",
  "era": "era",
  "hour": "hora",
  "minute": "minuto",
  "month": "mes",
  "second": "segundo",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Fecha seleccionada: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Rango seleccionado: ".concat(args.startDate, " a ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Hora seleccionada: ".concat(args.time);
  },
  "startDate": "Fecha de inicio",
  "timeZoneName": "zona horaria",
  "weekday": "d\xEDa de la semana",
  "year": "a\xF1o"
};